/** Сводка по цепочке: сколько заработаем, за сколько времени и как это идёт. */

import type { Plan } from '@cdf/shared';

import { formatDuration, formatNumber, plural } from '../lib/format';

interface PlanSummaryProps {
  plan: Plan;
  doneCount: number;
  skippedCount: number;
  /** Бонусы, уже подтверждённые кнопкой «Готово». */
  earnedBonus: number;
}

export function PlanSummary({
  plan,
  doneCount,
  skippedCount,
  earnedBonus,
}: PlanSummaryProps): JSX.Element {
  const total = plan.stops.length;
  const progress = total === 0 ? 0 : (doneCount / total) * 100;

  return (
    <div className="summary">
      <div className="summary__row">
        <div className="summary__cell">
          <span className="summary__label">Заработок</span>
          <strong className="summary__value num">
            {formatNumber(earnedBonus)}
            <span className="summary__unit">/{formatNumber(plan.netBonus)} ₽</span>
          </strong>
        </div>
        <div className="summary__cell">
          <span className="summary__label">Время</span>
          <strong className="summary__value num">
            {formatDuration(plan.totalDurationS)}
          </strong>
        </div>
        <div className="summary__cell">
          <span className="summary__label">В час</span>
          <strong className="summary__value num">
            {formatNumber(Math.round(plan.bonusPerHour))} ₽
          </strong>
        </div>
      </div>

      <div className="summary__progress">
        <div
          className="progress"
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={total}
          aria-valuenow={doneCount}
          aria-label="Пройдено шагов"
        >
          <span className="progress__fill" style={{ width: `${progress}%` }} />
        </div>
        <span className="summary__caption">
          {doneCount} из {total} {plural(total, 'машины', 'машин', 'машин')}
          {skippedCount > 0 ? ` · пропущено ${skippedCount}` : ''}
        </span>
      </div>
    </div>
  );
}
